(function () {
  if (!document.getElementById('ToelyCartLimitPopup')) {
    document.body.insertAdjacentHTML(
      'beforeend',
      `
      <div class="toely-cart-limit-popup" id="ToelyCartLimitPopup">
        <div class="toely-cart-limit-popup__box">
          <button
            type="button"
            class="toely-cart-limit-popup__close"
            aria-label="Close popup"
          >
            ×
          </button>

          <p class="toely-cart-limit-popup__text">
            You’ve reached the order limit for a single purchase.<br>
            For larger orders, please contact us at info@toely.co.
          </p>

          <button class="toely-cart-limit-popup__button" type="button">
            Continue Shopping
          </button>
        </div>
      </div>
      `
    );
  }

  const PRODUCT_TAGS = {
    set: 'toely-set',
    towel: 'toely-towel',
    strap: 'toely-strap'
  };

  const PRODUCT_HANDLES = {
    set: 'starter-set',
    towel: 'additional-towel',
    strap: 'additional-strap'
  };

  const TOELY_PRODUCT_HANDLES = [
    PRODUCT_HANDLES.set,
    PRODUCT_HANDLES.towel,
    PRODUCT_HANDLES.strap
  ];

  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const TOWEL_COLORS = ['pink', 'blue', 'white'];

  const productPromiseCache = {};
  let variantIndexPromise = null;
  let addToCartRunning = false;

  function getRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function route(path) {
    return getRoot() + path.replace(/^\//, '');
  }

  function getSectionsUrl() {
    return window.location.pathname || '/';
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') return tags.split(',').map(tag => tag.trim());
    return [];
  }

  function showToelyCartLimitPopup() {
    document.getElementById('ToelyCartLimitPopup')?.classList.add('is-visible');
  }

  function hideToelyCartLimitPopup() {
    document.getElementById('ToelyCartLimitPopup')?.classList.remove('is-visible');
  }

  document.addEventListener('click', function(event) {
    if (
      event.target.matches('.toely-cart-limit-popup__button') ||
      event.target.matches('.toely-cart-limit-popup__close') ||
      event.target.id === 'ToelyCartLimitPopup'
    ) {
      hideToelyCartLimitPopup();
    }
  });
function openToelyHeaderCart() {
  const cartToggles = Array.from(
    document.querySelectorAll('[class*="ai-luxury-header__cart-toggle"]')
  );

  const cartToggle = cartToggles.find(element => {
    const style = window.getComputedStyle(element);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getBoundingClientRect().width > 0 &&
      element.getBoundingClientRect().height > 0
    );
  });

  if (cartToggle) {
    cartToggle.click();
  } else {
    console.warn('Toely: visible cart drawer toggle not found');
  }
}

  function getTowelMultiplier(variantTitle) {
    const title = (variantTitle || '').toLowerCase();

    if (title.includes('3 towel')) return 3;
    if (title.includes('2 towel')) return 2;

    return 1;
  }

  function getColorKey(options) {
    return (options || [])
      .map(option => String(option).toLowerCase())
      .find(option => TOWEL_COLORS.includes(option));
  }

  function getTowelOption(options) {
    return (options || []).find(option =>
      String(option).toLowerCase().includes('towel')
    );
  }

  function getTowelCountFromVariantLike(itemOrVariant) {
    return getTowelMultiplier(
      getTowelOption(itemOrVariant.variant_options || itemOrVariant.options || []) ||
      itemOrVariant.variant_title ||
      itemOrVariant.title
    );
  }

  async function getJSON(url) {
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Fetch failed: ' + url);
    return response.json();
  }

  async function postJSON(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    const json = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(json.description || json.message || 'Cart request failed');
    }

    return json;
  }

  async function postCart(endpoint, body) {
    return postJSON(route('cart/' + endpoint), body);
  }

  async function getCart() {
    return getJSON(route('cart.js'));
  }

  async function getProductData(handle) {
    if (!productPromiseCache[handle]) {
      productPromiseCache[handle] = getJSON(route('products/' + handle + '.js'))
        .catch(error => {
          delete productPromiseCache[handle];
          throw error;
        });
    }

    return productPromiseCache[handle];
  }

  async function getVariantIndex() {
    if (!variantIndexPromise) {
      variantIndexPromise = Promise.all(
        TOELY_PRODUCT_HANDLES.map(handle => getProductData(handle).then(product => ({ handle, product })))
      ).then(entries => {
        const index = new Map();

        entries.forEach(({ handle, product }) => {
          (product.variants || []).forEach(variant => {
            index.set(Number(variant.id), { handle, product, variant });
          });
        });

        return index;
      }).catch(error => {
        variantIndexPromise = null;
        throw error;
      });
    }

    return variantIndexPromise;
  }

  async function getProductByVariantId(variantId) {
    const index = await getVariantIndex();
    return index.get(Number(variantId)) || null;
  }

  function applyProductToCounts(counts, product, variantTitle, quantity) {
    const tags = normalizeTags(product.tags);

    if (tags.includes(PRODUCT_TAGS.set)) {
      counts.sets += quantity;
    } else if (tags.includes(PRODUCT_TAGS.towel)) {
      counts.towels += quantity * getTowelMultiplier(variantTitle);
    } else if (tags.includes(PRODUCT_TAGS.strap)) {
      counts.straps += quantity;
    }
  }

  function applyCartItemToCounts(counts, item) {
    if (item.handle === PRODUCT_HANDLES.set) {
      counts.sets += item.quantity;
    } else if (item.handle === PRODUCT_HANDLES.towel) {
      counts.towels += item.quantity * getTowelCountFromVariantLike(item);
    } else if (item.handle === PRODUCT_HANDLES.strap) {
      counts.straps += item.quantity;
    }
  }

  function countCartFromCart(cart) {
    const counts = { sets: 0, towels: 0, straps: 0 };

    (cart.items || []).forEach(item => {
      applyCartItemToCounts(counts, item);
    });

    return counts;
  }

  async function countCurrentCart() {
    const cart = await getCart();
    return countCartFromCart(cart);
  }

  function isAllowedCombination(sets, towels, straps) {
    if (sets === 0 && towels === 0 && straps === 0) return true;

    // Starter Sets only
    if (sets <= 3 && towels === 0 && straps === 0) return true;

    // 2 Starter Sets combinations
    if (sets === 2 && towels <= 1 && straps === 0) return true;
    if (sets === 2 && towels === 0 && straps <= 3) return true;
    if (sets === 2 && towels <= 1 && straps <= 1) return true;

    // 1 Starter Set combinations
    if (sets === 1 && towels <= 2 && straps === 0) return true;
    if (sets === 1 && towels === 0 && straps <= 10) return true;
    if (sets === 1 && towels <= 1 && straps <= 3) return true;

    // No Starter Set combinations
    if (sets === 0 && towels <= 3 && straps <= 3) return true;
    if (sets === 0 && towels === 0 && straps <= 10) return true;

    return false;
  }

  function getQuantityFromFormData(formData) {
    const parsed = parseInt(formData.get('quantity') || '1', 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  }

  async function getAddContext(form) {
    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    const quantity = getQuantityFromFormData(formData);

    const [cart, productData] = await Promise.all([
      getCart(),
      getProductByVariantId(variantId)
    ]);

    const counts = countCartFromCart(cart);

    if (productData) {
      applyProductToCounts(
        counts,
        productData.product,
        productData.variant.title,
        quantity
      );
    }

    return {
      form,
      formData,
      variantId,
      quantity,
      cart,
      productData,
      counts,
      allowed: isAllowedCombination(counts.sets, counts.towels, counts.straps)
    };
  }

  async function wouldFormCartBeAllowed(form) {
    const context = await getAddContext(form);
    return context.allowed;
  }

  function getSectionHtml(sectionHtml, selector) {
    return new DOMParser()
      .parseFromString(sectionHtml, 'text/html')
      .querySelector(selector);
  }

  function renderToelyCartSections(parsedState) {
    const sections = parsedState?.sections;
    if (!sections) return false;

    let rendered = false;
    const currentDrawer = document.querySelector('cart-drawer');
    const currentBubble = document.querySelector('#cart-icon-bubble');

    if (currentDrawer && sections['cart-drawer']) {
      const newDrawer = getSectionHtml(sections['cart-drawer'], 'cart-drawer');

      if (newDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        rendered = true;
      }
    }

    if (currentBubble && sections['cart-icon-bubble']) {
      const newBubble = getSectionHtml(sections['cart-icon-bubble'], '#cart-icon-bubble');

      if (newBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
        rendered = true;
      }
    }

    return rendered;
  }

  async function refreshToelyCartSections() {
    const url = getSectionsUrl() + '?sections=' + encodeURIComponent(CART_SECTIONS.join(','));
    const sections = await getJSON(url);
    const parsedState = { sections };
    renderToelyCartSections(parsedState);
    return parsedState;
  }

  async function addFormDataToCart(formData) {
    formData.set('sections', CART_SECTIONS.join(','));
    formData.set('sections_url', getSectionsUrl());

    const response = await fetch(route('cart/add.js'), {
      method: 'POST',
      body: formData
    });

    const json = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(json.description || json.message || 'Cart add failed');
    }

    return json;
  }

  function buildTowelVariantMap(product) {
    const variantsByColorAndCount = {};

    (product.variants || []).forEach(variant => {
      const color = getColorKey(variant.options || []);
      if (!color) return;

      const count = getTowelCountFromVariantLike(variant);

      if (!variantsByColorAndCount[color]) {
        variantsByColorAndCount[color] = {};
      }

      variantsByColorAndCount[color][count] = Number(variant.id);
    });

    return variantsByColorAndCount;
  }

  function groupAdditionalTowelsByColor(cart) {
    const groups = {};

    (cart.items || []).forEach(item => {
      if (item.handle !== PRODUCT_HANDLES.towel) return;

      const color = getColorKey(item.variant_options || []);
      if (!color) return;

      const towelCountPerVariant = getTowelCountFromVariantLike(item);
      const totalTowelsForLine = towelCountPerVariant * item.quantity;

      if (!groups[color]) {
        groups[color] = {
          total: 0,
          keys: [],
          lines: []
        };
      }

      groups[color].total += totalTowelsForLine;
      groups[color].keys.push(item.key);
      groups[color].lines.push(item);
    });

    return groups;
  }

  async function addAdditionalTowelWithNormalization(context) {
    const product = context.productData.product;
    const selectedVariant = context.productData.variant;
    const selectedColor = getColorKey(selectedVariant.options || []);

    if (!selectedColor) {
      return addFormDataToCart(context.formData);
    }

    const selectedTowelCount = getTowelCountFromVariantLike(selectedVariant);
    const incomingTowels = selectedTowelCount * context.quantity;
    const groups = groupAdditionalTowelsByColor(context.cart);
    const existingGroup = groups[selectedColor] || { total: 0, keys: [] };
    const nextTotal = existingGroup.total + incomingTowels;
    const variantsByColorAndCount = buildTowelVariantMap(product);
    const targetVariantId = variantsByColorAndCount[selectedColor]?.[nextTotal];

    if (nextTotal < 1 || nextTotal > 3 || !targetVariantId) {
      showToelyCartLimitPopup();
      return null;
    }

    if (existingGroup.keys.length) {
      const updates = {};
      existingGroup.keys.forEach(key => {
        updates[key] = 0;
      });

      await postCart('update.js', { updates });
    }
const targetVariant = (product.variants || []).find(
  variant => Number(variant.id) === Number(targetVariantId)
);

const compareAtPrice = targetVariant?.compare_at_price
  ? '$' + (targetVariant.compare_at_price / 100).toFixed(2)
  : '';

return postCart('add.js', {
  items: [
    {
      id: targetVariantId,
      quantity: 1,
      properties: {
        _compare_at_price: compareAtPrice
      }
    }
  ],
  sections: CART_SECTIONS.join(','),
  sections_url: getSectionsUrl()
});
}

async function normalizeAdditionalTowelsInCart(options = {}) {
    const shouldRenderSections = options.renderSections !== false;
    const [product, cart] = await Promise.all([
      getProductData(PRODUCT_HANDLES.towel),
      getCart()
    ]);

    const variantsByColorAndCount = buildTowelVariantMap(product);
    const cartTowelsByColor = groupAdditionalTowelsByColor(cart);
    const updates = {};
    const items = [];

    Object.keys(cartTowelsByColor).forEach(color => {
      const group = cartTowelsByColor[color];
      const totalTowels = group.total;
      const targetVariantId = variantsByColorAndCount[color]?.[totalTowels];

      if (totalTowels < 1 || totalTowels > 3 || !targetVariantId) return;

      const alreadyNormalized =
        group.lines.length === 1 &&
        Number(group.lines[0].variant_id) === Number(targetVariantId) &&
        Number(group.lines[0].quantity) === 1;

      if (alreadyNormalized) return;

      group.keys.forEach(key => {
        updates[key] = 0;
      });

      const targetVariant = (product.variants || []).find(
  variant => Number(variant.id) === Number(targetVariantId)
);

const compareAtPrice = targetVariant?.compare_at_price
  ? '$' + (targetVariant.compare_at_price / 100).toFixed(2)
  : '';

items.push({
  id: targetVariantId,
  quantity: 1,
  properties: {
    _compare_at_price: compareAtPrice
  }
});
    });

    const hasUpdates = Object.keys(updates).length > 0;

    if (!hasUpdates && !items.length) {
      return cart;
    }

    if (hasUpdates) {
      await postCart('update.js', { updates });
    }

    if (!items.length) {
      const parsedState = await refreshToelyCartSections();
      return parsedState;
    }

    const parsedState = await postCart('add.js', {
      items,
      sections: CART_SECTIONS.join(','),
      sections_url: getSectionsUrl()
    });

    if (shouldRenderSections) {
      renderToelyCartSections(parsedState);
    }

    return parsedState;
  }

  function setFormLoading(form, loading) {
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!submitButton) return;

    submitButton.toggleAttribute('disabled', loading);
    submitButton.classList.toggle('toely-is-loading', loading);
  }

  async function addToCartAjax(form) {
    if (addToCartRunning) return;

    addToCartRunning = true;
    setFormLoading(form, true);

    try {
      const context = await getAddContext(form);

      if (!context.allowed) {
        showToelyCartLimitPopup();
        return;
      }

      const parsedState = context.productData?.handle === PRODUCT_HANDLES.towel
        ? await addAdditionalTowelWithNormalization(context)
        : await addFormDataToCart(context.formData);

      if (!parsedState) return;

      if (!renderToelyCartSections(parsedState)) {
        await refreshToelyCartSections();
      }

      requestAnimationFrame(function () {
        openToelyHeaderCart();
      });
    } catch (error) {
      console.error('Toely cart logic error:', error);
    } finally {
      addToCartRunning = false;
      setFormLoading(form, false);
    }
  }

  document.addEventListener('submit', function(event) {
    const form = event.target;

    if (!form || !form.action || !form.action.includes('/cart/add')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    addToCartAjax(form);

    return false;
  }, true);

  document.addEventListener('click', function(event) {
    const button = event.target.closest('button[type="submit"], input[type="submit"]');
    if (!button) return;

    const form = button.closest('form');
    if (!form || !form.action || !form.action.includes('/cart/add')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    addToCartAjax(form);

    return false;
  }, true);

 async function changeAdditionalTowelBundleQuantity(key, change) {
  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();

  const item = (cart.items || []).find((i) => i.key === key);

  if (!item || item.handle !== 'additional-towel') {
    return false;
  }

  const product = await getProductData('additional-towel');

  const color = item.variant_options?.find(option =>
    ['pink', 'blue', 'white'].includes(String(option).toLowerCase())
  );

  if (!color) return false;

  const towelOption = item.variant_options?.find(option =>
    String(option).toLowerCase().includes('towel')
  );

  const currentCount = getTowelMultiplier(
    towelOption || item.variant_title
  );

  const currentLineTowelCount = currentCount * (Number(item.quantity) || 1);
  const nextCount = currentCount + change;

  if (nextCount < 1) {
    return false;
  }

  const countsAfterChange = { sets: 0, towels: 0, straps: 0 };

  (cart.items || []).forEach((cartItem) => {
    if (cartItem.handle === 'starter-set') {
      countsAfterChange.sets += cartItem.quantity;
    }

    if (cartItem.handle === 'additional-towel') {
      const cartItemTowelOption = cartItem.variant_options?.find(option =>
        String(option).toLowerCase().includes('towel')
      );

      countsAfterChange.towels += getTowelMultiplier(
        cartItemTowelOption || cartItem.variant_title
      ) * cartItem.quantity;
    }

    if (cartItem.handle === 'additional-strap') {
      countsAfterChange.straps += cartItem.quantity;
    }
  });

  // Check the full cart after the clicked row would be changed.
  // Example: pink 2-pack + white 1-pack = 3 towels.
  // Clicking + on white would make it 4 towels, so block it.
  countsAfterChange.towels =
    countsAfterChange.towels - currentLineTowelCount + nextCount;

  if (
    nextCount > 3 ||
    !isAllowedCombination(
      countsAfterChange.sets,
      countsAfterChange.towels,
      countsAfterChange.straps
    )
  ) {
    showToelyCartLimitPopup();
    return true;
  }

  const targetVariant = product.variants.find((variant) => {
    const options = variant.options || [];

    const variantColor = options.find(option =>
      ['pink', 'blue', 'white'].includes(String(option).toLowerCase())
    );

    const variantTowelOption = options.find(option =>
      String(option).toLowerCase().includes('towel')
    );

    const variantCount = getTowelMultiplier(
      variantTowelOption || variant.title
    );

    return (
      String(variantColor).toLowerCase() === String(color).toLowerCase() &&
      variantCount === nextCount
    );
  });

  if (!targetVariant) return false;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: item.key,
      quantity: 0
    })
  });

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
  id: targetVariant.id,
  quantity: 1,
  properties: {
    _compare_at_price: targetVariant.compare_at_price
      ? '$' + (targetVariant.compare_at_price / 100).toFixed(2)
      : ''
  }
})
  });

  await refreshToelyCartSections();

  return true;
}

  // Warm up product and variant data in parallel so the first click does less work.
  getVariantIndex().catch(function(error) {
    console.warn('Toely product preload failed:', error);
  });

  window.ToelyCartLimit = {
    addToCartAjax,
    changeAdditionalTowelBundleQuantity,
    showPopup: showToelyCartLimitPopup,
    countCurrentCart,
    applyProductToCounts,
    getProductByVariantId,
    isAllowedCombination,
    normalizeAdditionalTowelsInCart,
    refreshToelyCartSections,
    renderToelyCartSections,
    wouldFormCartBeAllowed,

    async wouldCartBeAllowed({ handle, quantity = 1 }) {
      const counts = await countCurrentCart();

      if (handle === PRODUCT_HANDLES.set) {
        counts.sets += quantity;
      }

      if (handle === PRODUCT_HANDLES.towel) {
        counts.towels += quantity;
      }

      if (handle === PRODUCT_HANDLES.strap) {
        counts.straps += quantity;
      }

      return isAllowedCombination(counts.sets, counts.towels, counts.straps);
    }
  };
})();